<div class="flex gap-2 items-center text-body-regular">
  <div class="w-7 shrink-0"></div>
  <div class="flex flex-col">
    <ng-container *ngFor="let message of data.messages; trackBy: trackByMessage">
      <span
        [innerHTML]="
          data.isHtml ? message : data.type === 'error' ? ('error.' + message | translate) : (message | translate)
        "
      ></span>
    </ng-container>
  </div>
  <div class="flex items-center justify-end shrink-0 w-8 ml-auto">
    <mat-icon
      svgIcon="close"
      class="w-5 h-5 text-gray-light hover:text-gray hover:cursor-pointer"
      (click)="closeSnackbar()"
    ></mat-icon>
  </div>
</div>
